import { loadFromLocalStorage, saveToLocalStorage } from "./systemUtils";

const _keyMockSuggestions = "sugMock";
const _keyEndpointLocalAI = "endLocAI";
const _keyEndpointLocalTomato = "endLocTomato";
const _keyConfigTutorial = "splash";

let _endpointAI = '';
let _endpointTomato = '';

fetch("./endpoint/ai").then(async (e) => {
  _endpointAI = await e.text();
});

fetch("./endpoint/tomato").then(async (e) => {
   _endpointTomato = await e.text();
});

export const getEndpointAI = () => {
  return _endpointAI;
};

export const getEndpointTomato = () => {
  return _endpointTomato;
};

export const setMockSuggestions = (value) => {
  saveToLocalStorage(_keyMockSuggestions, value);
};

export const getMockSuggestions = () => {
  return loadFromLocalStorage(_keyMockSuggestions) === "true";
};

export const setEndpointLocalAI = (value) => {
  saveToLocalStorage(_keyEndpointLocalAI, value);
};

export const getEndpointLocalAI = () => {
  return loadFromLocalStorage(_keyEndpointLocalAI) === "true";
};

export const setEndpointLocalTomato = (value) => {
  saveToLocalStorage(_keyEndpointLocalTomato, value);
};

export const getEndpointLocalTomato = () => {
  return loadFromLocalStorage(_keyEndpointLocalTomato) === "true";
};

export const getConfigTutorial = () => {
  return loadFromLocalStorage(_keyConfigTutorial) ?? 0;
}

export const setConfigTutorial = (value) => {
  saveToLocalStorage(_keyConfigTutorial, value)
}
